import { styled } from '@/styles/stitches.config';
import { useDropdownMenu } from '@/utils/use-dropdown-menu';
import { Trans, t } from '@lingui/macro';
import { LinkTo } from '@/components/link-to';
import { Menu, MenuItem } from './menu';
import { IconDownload } from '@/assets/svg/icon-download';

const Relative = styled('div', {
  position: 'relative',
});

const Button = styled('button', {
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center',
  gap: '10px',
  color: '$white',
  backgroundColor: '$unicef',
  paddingBlock: '4px',
  paddingInline: '$5',
  borderRadius: '$3',
  border: '1px solid white',
  fontSize: '20px',
  fontWeight: '500',
  lineHeight: '45px',
  width: '100%',
  maxWidth: '17.5rem',

  '&:hover': {
    textDecoration: 'none',
    borderColor: '$white',
    color: '$unicef',
    backgroundColor: '$white',
  },

  '&:focus-visible, &.focus-visible': {
    textDecoration: 'none',
    borderColor: '$white',
    borderStyle: 'dotted',
    borderWidth: 3,
    outline: 'none',
  },

  variants: {
    color: {
      light: {
        color: '$unicef',
        borderColor: '$unicef',
        backgroundColor: '$white',
        '&:hover': {
          backgroundColor: '$unicef',
          color: '$white',
        },
        '&:focus-visible, &.focus-visible': {
          borderColor: '$unicef',
        },
      },
    },
  },
});

export function DownloadReportButton({
  colorVariant,
  singleTranslationUrl,
}: {
  colorVariant?: 'light';
  singleTranslationUrl?: string;
}) {
  const { getButtonProps, getMenuProps, getRootProps } = useDropdownMenu<HTMLDivElement>();

  const download = t({
    id: 'about.report-download-filename',
    message: 'unicef-changing-childhood-report.pdf',
  });

  return (
    <Relative {...getRootProps()}>
      {singleTranslationUrl && (
        <LinkTo download={download} hrefLang="en" href={singleTranslationUrl}>
          <Button color={colorVariant} {...getButtonProps()}>
            <IconDownload style={{ width: '19px' }} />
            <Trans id="about.download-report">Download Report</Trans>
          </Button>
        </LinkTo>
      )}
      {!singleTranslationUrl && (
        <>
          <Button color={colorVariant} {...getButtonProps()}>
            <IconDownload style={{ width: '19px' }} />
            <Trans id="about.download-report">Download Report</Trans>
          </Button>
          <Menu alignment={'left'} direction={'down'} {...getMenuProps()}>
            <MenuItem>
              <LinkTo
                download={download}
                hrefLang="en"
                href="https://www.unicef.org/globalinsight/media/2266/file"
              >
                English
              </LinkTo>
            </MenuItem>
            <MenuItem>
              <LinkTo
                download={download}
                hrefLang="es"
                href="https://www.unicef.org/globalinsight/media/2286/file"
              >
                Español
              </LinkTo>
            </MenuItem>
            <MenuItem>
              <LinkTo
                download={download}
                hrefLang="fr"
                href="https://www.unicef.org/globalinsight/media/2291/file"
              >
                Français
              </LinkTo>
            </MenuItem>
            <MenuItem>
              <LinkTo
                download={download}
                hrefLang="ar"
                href={'https://www.unicef.org/globalinsight/media/2296/file'}
              >
                عربي
              </LinkTo>
            </MenuItem>
          </Menu>
        </>
      )}
    </Relative>
  );
}
